module.exports = __webpack_public_path__ + "static/media/icon-check-list-checked.c7f15675.svg";